import { cloneElement, ComponentProps, isValidElement, ReactElement } from 'react';

import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import { IconWrapperComponent } from '@hh.ru/magritte-ui-icon/types';

const WrapperMockComponent = ({
    'data-qa': dataQa,
    disabled,
    tabIndex,
    children,
    ...props
}: ComponentProps<IconWrapperComponent>): ReactElement => {
    const isComponentDisabled = useDisabled() || !!disabled;
    if (props.onClick) {
        return (
            <button
                type={'button'}
                data-qa={dataQa}
                onClick={props.onClick}
                disabled={isComponentDisabled}
                tabIndex={tabIndex}
            >
                {isValidElement(children) ? cloneElement(children as ReactElement, { 'data-qa': undefined }) : children}
            </button>
        );
    }

    return <>{children}</>;
};

export default WrapperMockComponent;
